export default __webpack_public_path__ + "static/media/pasta.576dce68.webp";